module.exports = __webpack_public_path__ + "b9847b98e7158b8a6883c5ac0346a8a9.webm";